import { useState, useEffect } from "react";

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleTicketClick = () => {
    window.location.href = "https://secure.touchnet.net/C20832_ustores/web/store_main.jsp?STOREID=178&SINGLESTORE=true";
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      // 최상단 또는 최하단에서는 숨김
      if (scrollY === 0 || scrollY + windowHeight >= documentHeight) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // 초기 실행

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* 하단 고정 버튼 */}
      {isVisible && (
        <div className="desktop:hidden tablet:hidden fixed bottom-0 left-1/2 -translate-x-1/2 w-full bg-black/25 backdrop-blur-[36px] rounded-t-[30px] flex justify-between items-center h-[92px] shadow-lg z-50">
          {/* 텍스트 */}
          <div className="font-monasanssemicondensed font-semibold text-[16px] text-white m-[28px]">
            <p>
              Limited time <span className="text-indigo-300 font-semibold">offer</span>
            </p>
            <p>until Feb 21</p>
          </div>

          {/* 버튼 */}
          <button className="fill font-medium text-[18px] white_a700_19 button ui !rounded-[20px] text-[22px] px-[34px] h-[58px] self-stretch font-monasanssemicondensed !font-bold !text-white cursor-pointer m-[14px]"
                onClick={handleTicketClick}>
            Get tickets
          </button>
        </div>
      )}
    </>
  );
};

export default FloatingCTA;
